import { useMutation } from '@apollo/react-hooks';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { useEffect } from 'react';

import { ArticleViewedMutation } from '../../api/mutations/articleViewed.gql';

const ArticleViewed = ({ id, type }) => {
  const [articleViewed, result] = useMutation(ArticleViewedMutation);

  const dataArticleViewed = get(result.data, 'articleViewed');
  const sendMutation = !result.loading && !dataArticleViewed;

  useEffect(() => {
    if (sendMutation) {
      articleViewed({ variables: { id, type } });
    }
  }, [articleViewed, id, sendMutation, type]);

  return null;
};

ArticleViewed.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default ArticleViewed;
